import React, {useState} from 'react';
import { useTranslate } from 'react-redux-multilingual'
// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Modal } from "react-bootstrap";

const DuplicateBtn = (props) => {
    const t = useTranslate();
    const [show,setShow] = useState(false)
    const [selectTauxToDuplicate,setSelectTauxToDuplicate] = useState([])

    const handleClick = () => {
        setShow(true)
    }

    const selectTaux = (taux) => {
        if(selectTauxToDuplicate.includes(taux)){
            setSelectTauxToDuplicate(selectTauxToDuplicate.filter(value=>value!=taux))
        }else{
            setSelectTauxToDuplicate([...selectTauxToDuplicate,taux])
        }
    };

    const submitDuplicate = () => {
        let obj = {
            ...props.ventialtionArticleTaxeValue,
        }

        selectTauxToDuplicate.map(value=>{
            obj[value] = props.ventialtionArticleTaxeValue[props.colTaux]
        })

        props.setVentialtionArticleTaxeValue(obj)
        setSelectTauxToDuplicate([])
        setShow(false)
    };

    return (<>
            <Modal size="md" show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('duplicateBreakdown')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <p>{t('selectConf')}</p>
                        {props.authParam.company.advanceparams.taux_tgc.map(taux=>{
                            if(taux!=props.colTaux){
                                return(
                                    <button 
                                        key={taux} 
                                        className={`btn ${selectTauxToDuplicate.includes(taux) ? "btn-success" : "btn-outline-success"}`} 
                                        style={{marginLeft:'1rem'}}
                                        onClick={()=>selectTaux(taux)} 
                                    >
                                        {props.authParam.company.nomenclature_tgc+' '+taux+'%'}
                                    </button>
                                )
                            }
                        })}

                        <button className='btn btn-primary d-block mt-5' onClick={()=>submitDuplicate()}>
                            {t('btnValidate')}
                        </button>
                    </>
                </Modal.Body>
            </Modal>
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip id={`tooltip-${props.index}`}>
                        {t('duplicateBreakdown')}
                    </Tooltip>
                }
            >
                <span onClick={() => handleClick()} style={{cursor:'Pointer'}} className='text-info'><FontAwesomeIcon icon={faCopy} /></span>
            </OverlayTrigger> 
        </> 
    )
}

export default DuplicateBtn;